import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "dashboard fs_box_wrapper"
};
var _hoisted_2 = {
  "class": "fs_box fs_dashboard_box fs_box_narrow"
};
var _hoisted_3 = {
  "class": "fs_box_header",
  style: {
    "padding": "10px 15px",
    "font-size": "16px"
  }
};
var _hoisted_4 = {
  "class": "fs_box_actions"
};
var _hoisted_5 = {
  "class": "fs_box_body fs_padded_20"
};
var _hoisted_6 = {
  "class": "fframe_pagination_wrapper",
  style: {
    "margin-top": "20px",
    "text-align": "right"
  }
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  "class": "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_router_link = _resolveComponent("router-link");
  var _component_el_popconfirm = _resolveComponent("el-popconfirm");
  var _component_el_table = _resolveComponent("el-table");
  var _component_pagination = _resolveComponent("pagination");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_form_item = _resolveComponent("el-form-item");
  var _component_el_form = _resolveComponent("el-form");
  var _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[7] || (_cache[7] = _createElementVNode("div", {
    "class": "fs_box_head"
  }, [_createElementVNode("h3", null, "All Data Connect Feeds")], -1 /* HOISTED */)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.adding_new = true;
    })
  }, {
    "default": _withCtx(function () {
      return _cache[6] || (_cache[6] = [_createTextVNode("Add New Connector")]);
    }),
    _: 1 /* STABLE */
  })])]), _createElementVNode("div", _hoisted_5, [$data.all_loaded ? (_openBlock(), _createBlock(_component_el_table, {
    key: 0,
    data: $data.feeds,
    border: "",
    stripe: ""
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "id",
        label: "ID",
        width: "90"
      }), _createVNode(_component_el_table_column, {
        label: "Title"
      }, {
        "default": _withCtx(function (scope) {
          return [_createVNode(_component_router_link, {
            to: {
              name: 'edit_connector',
              params: {
                feed_id: scope.row.id
              }
            }
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(scope.row.title), 1 /* TEXT */)];
            }),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])];
        }),
        _: 1 /* STABLE */
      }), _createVNode(_component_el_table_column, {
        prop: "status",
        label: "Status",
        width: "120"
      }), _createVNode(_component_el_table_column, {
        label: "Actions",
        width: "120"
      }, {
        "default": _withCtx(function (scope) {
          return [_createVNode(_component_router_link, {
            to: {
              name: 'edit_connector',
              params: {
                feed_id: scope.row.id
              }
            }
          }, {
            "default": _withCtx(function () {
              return _cache[8] || (_cache[8] = [_createElementVNode("i", {
                "class": "el-icon-edit"
              }, null, -1 /* HOISTED */)]);
            }),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]), _createVNode(_component_el_popconfirm, {
            "confirm-button-text": "Yes, Delete this",
            "cancel-button-text": "No",
            icon: "el-icon-info",
            "icon-color": "red",
            title: "Are you sure to delete this? All associate data connectors will be deleted too",
            onConfirm: function onConfirm($event) {
              return $options.deleteConnector(scope.row.id);
            }
          }, {
            reference: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                style: {
                  "margin-left": "10px",
                  "color": "red"
                },
                type: "text",
                size: "mini",
                icon: "el-icon-delete"
              })];
            }),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onConfirm"])];
        }),
        _: 1 /* STABLE */
      })];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data"])) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_6, [_createVNode(_component_pagination, {
    onFetch: _cache[1] || (_cache[1] = function ($event) {
      return $options.fetch();
    }),
    pagination: $data.pagination
  }, null, 8 /* PROPS */, ["pagination"])]), $data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_skeleton, {
    rows: 3,
    animated: ""
  })])) : _createCommentVNode("v-if", true)])]), _createVNode(_component_el_dialog, {
    modelValue: $data.adding_new,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.adding_new = $event;
    }),
    "append-to-body": true,
    title: "Add a New Data Connect Feed",
    width: "60%"
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return $data.adding_new = false;
        })
      }, {
        "default": _withCtx(function () {
          return _cache[9] || (_cache[9] = [_createTextVNode("Cancel")]);
        }),
        _: 1 /* STABLE */
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return $options.addFeed();
        })
      }, {
        "default": _withCtx(function () {
          return _cache[10] || (_cache[10] = [_createTextVNode("Continue")]);
        }),
        _: 1 /* STABLE */
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_form, {
        "label-position": "top",
        data: $data.new_feed
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: "Data Connector Title"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_input, {
                type: "text",
                placeholder: "Connector Title",
                modelValue: $data.new_feed.title,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return $data.new_feed.title = $event;
                })
              }, null, 8 /* PROPS */, ["modelValue"])];
            }),
            _: 1 /* STABLE */
          })];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data"])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"])]);
}